/** 
 * Minimum widths for products and banners in pixels
 */
export const MIN_PRODUCT_WIDTH = 120;
export const MIN_BANNER_WIDTH = 280;

export const GAP = 12;